import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconUserFilled = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 32,
	viewBox: "0 0 28 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M14 16C11.125 16 8.5 14.5 7.0625 12C5.625 9.5625 5.625 6.5 7.0625 4C8.5 1.5625 11.125 0 14 0C16.8125 0 19.4375 1.5625 20.875 4C22.3125 6.5 22.3125 9.5625 20.875 12C19.4375 14.5 16.8125 16 14 16ZM11.125 19H16.8125C23 19 28 24 28 30.1875C28 31.1875 27.125 32 26.125 32H1.8125C0.8125 32 0 31.1875 0 30.1875C0 24 4.9375 19 11.125 19Z",
		fill: "#D9D9D9"
	})]
});
const ForwardRef = forwardRef(SvgIconUserFilled);
export { ForwardRef as ReactComponent };
